import * as React from "react";
import { Link } from "@grandvisionhq/common";
/* empty css                         */
const ProductBlockDetails = ({ children, href, tabIndex, onClick }) => {
  return /* @__PURE__ */ React.createElement(Link, { href, onClick, className: "product-block-details", tabIndex }, children);
};
export {
  ProductBlockDetails
};
//# sourceMappingURL=ProductBlockDetails.js.map
